import React from 'react';

import { useIntl } from 'react-intl-next';
import { usePathParam } from 'react-resource-router';

import { fg } from '@atlaskit/platform-feature-flags';
import { AutoComplete, getTeams } from '@atlassian/eoc-auto-complete';
import { ErrorMessage, EocField as Field } from '@atlassian/eoc-form';
import { useResponderNames } from '@atlassian/eoc-responder-names';

import { type FormData } from '../../../../common/types';

import messages from './messages';
import { SelectControl } from './select-control';

export const AssignedTeamInput = ({ ownerTeamId }: { ownerTeamId?: string }) => {
	const [teamId] = usePathParam('teamId');

	const { formatMessage } = useIntl();

	const [responderTeam] = useResponderNames(
		teamId
			? [{ type: 'team', id: teamId }]
			: ownerTeamId
				? [{ type: 'team', id: ownerTeamId }]
				: [],
	);

	return (
		<Field<FormData['assignedTeam']>
			aria-required={true}
			name="assignedTeam"
			label={formatMessage(messages.assignedTeamLabel)}
			isRequired
			initialValue={
				responderTeam && 'name' in responderTeam
					? {
							...responderTeam,
							label: responderTeam.name,
							value: responderTeam.atlassianIdentifier || responderTeam.id,
						}
					: undefined
			}
			validate={(value) => {
				if (!value) {
					return 'error';
				}
			}}
		>
			{({ input, meta }) => (
				<>
					<AutoComplete
						{...input}
						inputId={input.id}
						endpoints={[getTeams]}
						components={{
							DropdownIndicator: () => <></>,
							Control: (props) => <SelectControl responder={responderTeam} {...props} />,
						}}
						placeholder=""
						isOptionSelected={() => false}
						isLoading={responderTeam?.isLoading}
						isDisabled={fg('global_heartbeats') ? !!teamId : true}
					/>
					{meta.touched && meta.error && (
						<ErrorMessage>{formatMessage(messages.assignedTeamErrorText)}</ErrorMessage>
					)}
				</>
			)}
		</Field>
	);
};
